export default "__VITE_ASSET__Bj_owUra__"